import React, { FC } from 'react'
import { CategoryPointLegend } from 'models/legend'
import { Flex } from 'components/Flex'
import { Icon } from 'components/Icon'
import { Text } from 'components/Text'
import { Stack } from 'components/Stack'
import styles from './CategoryPoint.module.scss'

type CategoryPointProps = {
  data: CategoryPointLegend[]
}

const DEFAULT_ICON = 'checkbox-blank-circle-fill'

const renderCategorySymbol = ({ color, icon, image }: CategoryPointLegend) => {
  if (image) {
    return <img src={image} alt="" className={styles.image} />
  }

  return <Icon name={icon ?? DEFAULT_ICON} style={{ color }} />
}

export const CategoryPoint: FC<CategoryPointProps> = ({ data }) => {
  return (
    <Stack space="small">
      {data.map((category, index) => (
        <Flex align="center" gap="sm" key={index}>
          {renderCategorySymbol(category)}
          <Text size="small">{category.name}</Text>
        </Flex>
      ))}
    </Stack>
  )
}

CategoryPoint.displayName = 'CategoryPoint'
